module.exports = __webpack_public_path__ + "static/img/category5v.104fa15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/category5v.jpg
// module id = AeEk
// module chunks = 0